import a from"./checkPrivateRedeclaration.js";function e(e,t){a(e,t),t.add(e)}export{e as default};
